<template>

    <evp-layout>
        <div
            v-if="currentRoute.name != 'InstitutionPage' && currentRoute.name != 'InstitutionPageMap' && currentRoute.name != 'FavoriteSpecialists'"
            class="flex flex-col md:flex-row md:items-center justify-between mb-1"
        >
            <navigation-header
                :return-url="route('booking-appointments')"
                :title="currentRoute.name === 'Telemedicine' ? $t('global.TelemedicineTitle') : $t('booking.NewRecord')"
            />

            <map-view-switch
                class="self-center mt-1.5 mb-4 md:my-0"
                v-if="currentRoute.name != 'FavoriteSpecialists'
                    && currentRoute.name != 'InstitutionPage'
                    && currentRoute.name != 'InstitutionPageMap'
                    && (currentRoute.name != 'Institutions' || currentRoute.query.ServiceCode)
                    && currentRoute.name != 'Services'
                    && currentRoute.name != 'Specialists'
                    && (
                        currentRoute.name != 'InstitutionMap'
                        || !['Institutions', 'Services', 'Specialists'].includes(currentRoute.params.section)
                        || (currentRoute.params.section === 'Institutions' && currentRoute.query.ServiceCode)
                    )
                    && !bookingStore.isTelemedicineSelected()
                "
            />
        </div>

        <!-- Izvēlētā iestāde, pakalpojums, ārsts -->
        <back-link
            v-for="(link, index) in bookingStore.selectedItems"
            :key="index"
            :item="link.item"
            :type="link.type"
            @back="goBack(link.type)"
        ></back-link>

        <router-view :key="currentRoute.fullPath" />
    </evp-layout>

</template>
<script setup>
    import { useRoute } from 'vue-router'
    import { useBookingStore } from '@/js/booking/booking-search-store'
    import { goTo } from '@/js/booking/booking-search-router'
    import EvpLayout from '@/components/EvpLayout.vue'
    import BackLink from '@/components/booking/BackLink.vue'
    import MapViewSwitch from '@/components/booking/MapViewSwitch.vue'
    import { route } from 'ziggy'
    import NavigationHeader from '@/components/NavigationHeader.vue'

    const bookingStore = useBookingStore()
    const currentRoute = useRoute()


    /**
     * Ielādē lapu, kur var nomainīt padotā parametra vērtību.
     * 
     * @param {String} linkType - ja padod 'institution', tad ielādēs iestāžu sarakstu.
     */
    function goBack(linkType) {
        // Pāradresē, saglabājot kartes skatu, ja ir atvērts.
        const redirectTo = (section, query = {}, params = {}) => {
            if (currentRoute.name == 'InstitutionMap') {
                if (section === 'InstitutionPage') {
                    goTo('InstitutionPageMap', {
                        params: { ...params },
                        query,
                        mockBackButton: true,
                    })

                } else {
                    goTo('InstitutionMap', {
                        params: { section, ...params },
                        query,
                        mockBackButton: true,
                    })
                }

            } else {
                goTo(section, { 
                    query,
                    params,
                    mockBackButton: true,
                })
            }
        }

        if (linkType == 'institution') {
            if (bookingStore.isFirstSelectedItem('specialist')) {
                redirectTo('AvailableTimeSlots', {
                    SpecialistCode: bookingStore.selectedSpecialist?.specialistCode,
                    SpecialityCode: bookingStore.selectedSpecialist?.specialityCode,
                })
            
            } else {
                redirectTo('Institutions', {
                    ServiceCode: bookingStore.isFirstSelectedItem('service') ? bookingStore.selectedService?.serviceCode : null
                })
            }

        } else if (linkType == 'service') {
            if (bookingStore.isFirstSelectedItem('institution')) {
                redirectTo('InstitutionPage', {}, {
                    institutionCode: bookingStore.selectedInstitution.institutionCode,
                })

            } else if (bookingStore.isTelemedicineSelected()) {
                redirectTo('Telemedicine')
                
            } else {
                redirectTo('Services')
            }

        } else if (linkType == 'specialist') {
            if (bookingStore.isFirstSelectedItem('institution')) {
                redirectTo('InstitutionPage', {}, {
                    institutionCode: bookingStore.selectedInstitution.institutionCode,
                })

            } else if (bookingStore.isTelemedicineSelected()) {
                redirectTo('Telemedicine')
                
            } else {
                redirectTo('Specialists')
            }
        }
    }


    defineExpose({
        openInstitutionFromMap: bookingStore.selectInstitution,
        institutionMap: bookingStore.institutionMap,
    })

</script>
